import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import useCompanyService from "../../database/CompanyService";
import { RootState } from "../../app/store";
import useProductService from "../../database/ProductService";
import useVoucherService from "../../database/VoucherService";
import { Company } from "../../models/Company";

export interface AdministratorOptionsPageState {

}

const initialState: AdministratorOptionsPageState = {

}

export const AdministratorOptionsPageSlice = createSlice({
    name: 'administratorOptions',
    initialState,
    reducers: {

    }
});


export const {

} = AdministratorOptionsPageSlice.actions;

export default AdministratorOptionsPageSlice.reducer;

export const selectState = (state: RootState) => state.administratorOptionsPage;